export const RELOAD_SERVER_SETTINGS_REQUEST = 'RELOAD_SERVER_SETTINGS_REQUEST';

export const reloadServerSettingsRequest = () => ({
    type: RELOAD_SERVER_SETTINGS_REQUEST,
});
